module.exports = __webpack_public_path__ + "static/media/saocristovaoenevis.d6ac2229.jpg";